import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

// -------------------------
// Google Ads gtag Setup 
// -------------------------
const gtagScript = document.createElement("script");
gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-17739516385";
gtagScript.async = true;
document.head.appendChild(gtagScript);

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

gtag('js', new Date());
gtag('config', 'AW-17739516385');
// -------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

const clientId = "543205765015-47aserebk9ds5l6q0o6cltplop0sdt6c.apps.googleusercontent.com";

root.render(
  <GoogleOAuthProvider clientId={clientId}>
    <App />
  </GoogleOAuthProvider>
);

reportWebVitals();
